import { ViewMode } from 'types/galaxy';

export interface ViewOption {
  value: ViewMode;
  label: string;
  icon: string;
}

export const VIEW_MODES: ViewOption[] = [
  { value: 'spiral', label: 'Spiral Galaxy', icon: '🌀' },
  { value: 'mind', label: 'AI Mind Map', icon: '🧠' },
  { value: 'tiers', label: 'Tier Rings', icon: '◎' },
  { value: 'scatter', label: 'ROI × fROI', icon: '⬡' },
  { value: 'helix', label: 'PnL Helix', icon: '🧬' },
  { value: 'sphere', label: 'Globe', icon: '🌍' },
  { value: 'tornado', label: 'Vortex', icon: '🌪️' },
  { value: 'grid', label: 'Grid Map', icon: '▦' },
  { value: 'sunflower', label: 'Sunflower', icon: '🌻' },
  { value: 'dna', label: 'DNA', icon: '🔬' },
  { value: 'spring', label: 'Spring', icon: '🔩' },
  { value: 'clusters', label: 'Clusters', icon: '🪐' },
];

export const DEFAULT_VIEW_MODE: ViewMode = 'spiral';

export const VIEW_TRANSITION_SPEED = 0.012; // ~2.5 seconds at 60fps
